import { Injectable, Inject, Injector } from '@angular/core';
import { UrlBuilder } from '../../shared/classes/url-builder';
import { QueryStringParameters } from '../../shared/classes/query-string-parameters';
import { environment } from 'src/environments/environment';
import { FilterSelection } from '../classes/filterSelection';
import buildQuery from 'odata-query';
import { formatDate } from '@angular/common';
import { DataService } from './data.service';
import { filter } from 'rxjs/operators';

@Injectable()
export class ApiEndpointsService {
  constructor(private injector: Injector) {}

  public getMeEndpoint(): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(environment.API_ME, '');
    return urlBuilder.toString();
  }

  public getSapIdEndpoint(): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(environment.API_ENDPOINT_LECTURA, 'User');
    return urlBuilder.toString();
  }

  public getMembersEndPoint(): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.GET_ADMINS_URL,
      ''
    );
    return urlBuilder.toString();
  }

  public getTokeEndPoint(): string {
    let params = new QueryStringParameters();
    params.push('grant_type', 'client_credentials');
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.OAUTH_URL,
      '',
      params
    );
    return urlBuilder.toString();
  }

  public getTestSAPEndpoint(action: string): string {
    const urlBuilder: UrlBuilder = new UrlBuilder('store-locator', action);
    return urlBuilder.toString();
  }

  public getBrandsEndpoint(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);

    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((BRANDNAME,BRANDID))'
        );
      }
    );
  }

  public getPreferredTimeCall(): string {
    return this.createUrl('PreferredTimeCall');
  }

  public getPosType(): string {
    return this.createUrl('TypePOS');
  }

  public getSubBrandsByBrandEndpoint(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);

    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((SUBBRANDNAME,SUBBRANDID))'
        );
      }
    );
  }

  public getLinesBySubBrandEndpoint(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((LINENAME,LINEID))'
        );
      }
    );
  }

  public getFormatsByLineEndpoint(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((FORMATNAME,FORMATID))'
        );
      }
    );
  }

  getTAMedFilter(filterSelection: FilterSelection): FilterSelection {
    let tam = this.injector.get(DataService).getSapId();
    if (tam != '') {
      // generate filter with tamname
      filterSelection.tam = tam;
    } else {
      //generate filter without tamname
      filterSelection.tam = '';
    }
    ////console.log(filterSelection);
    return filterSelection;
  }

  public getDatosTiendaEndPoint(idfsAccount: any): string {
    //canviar por idfsAccount
    return this.createUrl("SF_DatosTienda('" + idfsAccount + "')");
  }

  public getDatosTiendaEndPointPatch(idfsAccount: any): string {
    //canviar por idfsAccount
    return this.createUrlPatch("SF_DatosTienda('" + idfsAccount + "')");
  }

  public getHorarioTiendaEndPoint(idfsAccount: any): string {
    //canviar por idfsAccount
    return this.createUrl("SF_HorarioTienda('" + idfsAccount + "')");
  }

  public getHorarioTiendaEndPointPatch(idfsAccount: any): string {
    //canviar por idfsAccount
    return this.createUrlPatch("SF_HorarioTienda('" + idfsAccount + "')");
  }

  public getDatosContactoEndPointPorAccountNumber(accountNumber: any): string {
    //canviar por Pos ID
    return this.createUrlWithQueryParameters(
      'SF_DatosContacto',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          "filter(ACCOUNTNUMBER eq '{{accountNumber}}')".replace(
            '{{accountNumber}}',
            accountNumber.toString()
          )
        );
      }
    );
  }

  public getDatosContactoEndPoint(idfsAccount: any): string {
    //canviar por idfsAccount
    return this.createUrl("SF_DatosContacto('" + idfsAccount + "')");
  }

  public getDatosContactoEndPointPatch(idfsAccount: any): string {
    //canviar por idfsAccount
    return this.createUrlPatch("SF_DatosContacto('" + idfsAccount + "')");
  }

  public getPosEndpointFromPos(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);

    return this.createUrlWithQueryParameters(
      'ListPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((ACCOUNTNUMBER,SOCUSTOMER,POS,CUSTOMER,COMERCIALNAME,FISCALNAME,FULLADDRESS,SHIPPINGSTREET,SHIPPINGCOUNTRY,SHIPPINGSTATE,SHIPPINGCITY,SHIPPINGPOSTALCODE,SHIPPINGLATITUDE,SHIPPINGLONGITUDE,IDRDC,NAMERDC,OPENINGHOURSINDICATOR,CONTACTINDICATOR,ORIGIN,NAMETAM))'
        );
        if (filter.skipToken != null && filter.skipToken != '') {
          qs.push('$skiptoken', filter.skipToken);
        }
      }
    );
  }

  public getFilterString(filter: FilterSelection) {
    let arrayFilters = this.getOdataFilters(filter);
    let filterString = '';
    if (arrayFilters.length > 0) {
      filterString = arrayFilters.join(' and ');
      filterString = 'filter(' + filterString + ')';
    }
    return filterString;
  }

  public getPosEndpoint(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);

    let filterString = this.getFilterString(filter);

    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((ACCOUNTNUMBER,SOCUSTOMER,POS,CUSTOMER,COMERCIALNAME,FISCALNAME,FULLADDRESS,SHIPPINGSTREET,SHIPPINGCOUNTRY,SHIPPINGSTATE,SHIPPINGCITY,SHIPPINGPOSTALCODE,SHIPPINGLATITUDE,SHIPPINGLONGITUDE,IDRDC,NAMERDC,OPENINGHOURSINDICATOR,CONTACTINDICATOR,ORIGIN,NAMETAM))'
        );
      }
    );
  }

  public getExistTamEndpoint(sapId: string): string {
    return this.createUrlWithQueryParameters(
      'ListPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          "filter(TAM eq '{{sapId}}')/groupby((TAM))".replace(
            '{{sapId}}',
            sapId
          )
        );
      }
    );
  }

  public getPosDetailEndpoint(posID: any): string {
    return this.createUrlWithQueryParameters(
      'DetailPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          "filter(POS eq '{{pos}}')".replace('{{pos}}', posID.toString())
        );
      }
    );
  }

  getOdataFilters(filter: FilterSelection) {
    let filterArray: string[] = [];

    //filterArray.push("SAPCODE ne '21'");

    if (filter.country != '') {
      filterArray.push("SHIPPINGCOUNTRY eq '" + filter.country + "'");
    }

    if (filter.region != '') {
      filterArray.push("SHIPPINGSTATE eq '" + filter.region + "'");
    }

    if (filter.subregion != '') {
      filterArray.push("SHIPPINGCITY eq '" + filter.subregion + "'");
    }

    if (filter.brand != '') {
      filterArray.push("BRANDID eq '" + filter.brand + "'");
    }

    if (filter.subbrand != '') {
      filterArray.push("SUBBRANDID eq '" + filter.subbrand + "'");
    }

    if (filter.line != '') {
      filterArray.push("LINEID eq '" + filter.line + "'");
    }

    if (filter.format != '') {
      filterArray.push('FORMATID eq ' + filter.format + '');
    }

    if (filter.tamName != '') {
      filterArray.push("NAMETAM eq '" + filter.tamName + "'");
    }

    if (filter.tam != '') {
      filterArray.push("TAM eq '" + filter.tam + "'");
    }

    //to-do: review this filter
    //if (filter.seller != '') {
    //  filterArray.push("IDRDC eq '" + filter.seller + "'");
    //}

    return filterArray;
  }

  public getCountries(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'ListPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((SHIPPINGCOUNTRY))'
        );
        qs.push('$orderby', '(SHIPPINGCOUNTRY)');
      }
    );
  }

  public getSellers(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'ListPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((IDRDC,NAMERDC))'
        );
        qs.push('$orderby', '(NAMERDC)');
      }
    );
  }

  public getRegions(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    ////console.log(filterString);
    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((SHIPPINGSTATE))'
        );
        qs.push('$orderby', '(SHIPPINGSTATE)');
      }
    );
  }

  public getCities(filter: FilterSelection): string {
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'ListProductPOS',
      (qs: QueryStringParameters) => {
        qs.push(
          '$apply',
          (filterString != '' ? filterString + '/' : '') +
            'groupby((SHIPPINGCITY))'
        );
        qs.push('$orderby', '(SHIPPINGCITY)');
      }
    );
  }

  public getPosAlertsEndpoint(): string {
    let filter: FilterSelection = new FilterSelection();
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'Avisos',
      (qs: QueryStringParameters) => {
        filterString != '' ? qs.push('$apply', filterString) : '';
      }
    );
  }

  public getPosAlertsCountEndpoint(): string {
    let filter: FilterSelection = new FilterSelection();
    filter = this.getTAMedFilter(filter);
    let filterString = this.getFilterString(filter);
    return this.createUrlWithQueryParameters(
      'Avisos/$count',
      (qs: QueryStringParameters) => {
        filterString != '' ? qs.push('$apply', filterString) : '';
      }
    );
  }

  public getProductsEnpoint(posID: any): string {
    let date = new Date();
    date.setMonth(date.getMonth() - 6);
    date.setHours(0);
    date.setMinutes(0);
    date.setMinutes(0);
    let stringDate = formatDate(date, 'YYYY-MM-dd', 'en-US');
    const transform = [
      {
        filter: {
          POS: posID,
          LASTPURCHASEDATE: {
            ge: { type: 'raw', value: stringDate },
          },
        },
      },
      {
        groupBy: {
          properties: [
            'POS',
            'MATNR',
            'DESCRIPTION',
            'BRANDID',
            'BRANDNAME',
            'SUBBRANDID',
            'SUBBRANDNAME',
            'LINEID',
            'LINENAME',
            'FORMATID',
            'FORMATNAME',
          ],
          transform: {
            aggregate: {
              LASTPURCHASEDATE: {
                with: 'max',
                as: 'LASTREALPURCHASEDATE',
              },
            },
          },
        },
      },
    ];
    let query = buildQuery({
      transform,
      orderBy: ['LASTREALPURCHASEDATE desc'],
    });
    return this.createUrlWithODataQuery('ProductPOS', query);
  }

  /* #region URL CREATOR */

  // URL
  private createUrl(action: string): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.API_ENDPOINT_LECTURA,
      action
    );
    return urlBuilder.toString();
  }

  // URL WITH oDATA QUERY PARAMS
  private createUrlWithODataQuery(action: string, query?: string): string {
    ////console.log(query);
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.API_ENDPOINT_LECTURA,
      action + query
    );
    return urlBuilder.toString();
  }
  // URL WITH QUERY PARAMS
  private createUrlWithQueryParameters(
    action: string,
    queryStringHandler?: (queryStringParameters: QueryStringParameters) => void
  ): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.API_ENDPOINT_LECTURA,
      action
    );
    // Push extra query string params
    if (queryStringHandler) {
      queryStringHandler(urlBuilder.queryString);
    }
    return urlBuilder.toString();
  }

  // URL WITH QUERY PARAMS
  private createUrlPatch(action: string): string {
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.API_ENDPOINT_ESCRITURA,
      action
    );
    return urlBuilder.toString();
  }

  // URL WITH PATH VARIABLES
  private createUrlWithPathVariables(
    action: string,
    pathVariables: any[] = []
  ): string {
    let encodedPathVariablesUrl: string = '';
    // Push extra path variables
    for (const pathVariable of pathVariables) {
      if (pathVariable !== null) {
        encodedPathVariablesUrl += `/${encodeURIComponent(
          pathVariable.toString()
        )}`;
      }
    }
    const urlBuilder: UrlBuilder = new UrlBuilder(
      environment.API_ENDPOINT_LECTURA,
      `${action}${encodedPathVariablesUrl}`
    );
    return urlBuilder.toString();
  }
  /* #endregion */
}
